import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { forbiddenPassword } from '../../shared/password.validator';
import { verifiedInvalid } from '../../shared/helpers';
import { environment } from '../../../environments/environment';
import { LoginResponse } from '../../shared/login.response';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalRecuperarContrasenaComponent } from '../modal-recuperar-contrasena/modal-recuperar-contrasena.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @Input() loginClass?: string;
  loginForm: FormGroup;
  showPassword = false;
  snackbarConfig: MatSnackBarConfig = {
    panelClass: 'account-request-snackbar',
    duration: 5000,
  };
  bsModalRef?: BsModalRef;
  public isError: boolean;
  public isLoading: boolean;

  constructor(
    private fb: FormBuilder,
    private service: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar,
    private modalService: BsModalService
  ) {
    this.isError = false;
    this.isLoading = false;
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.maxLength(20)]],
      contrasena: ['', [Validators.required]],
      recaptcha: [null, Validators.required],
    });
  }

  get invalidUsername(): boolean {
    return verifiedInvalid(this.loginForm.get('username'));
  }

  get invalidPassword(): boolean {
    return verifiedInvalid(this.loginForm.get('contrasena'));
  }
  get username(): string {
    return this.loginForm.get('username').value;
  }

  public async submit(): Promise<void> {
    if (this.loginForm.valid) {
      let ip = { ip: '' };
      try {
        ip = await this.service.getIp();
      } catch (error) {
        console.log('No se ha podido obtener la ip', error);
      }
      let logstatus = '';
      try {
        this.isError = false;
        this.isLoading = true;
        const resp: LoginResponse = await this.service.login(
          {
            username: this.username,
            contrasena: this.loginForm.get('contrasena').value,
            CONTEXT: environment.CONTEXT,
          },
          this.loginForm.get('recaptcha').value,
          { ip: ip.ip, usuario: this.username, menu: logstatus }
        );
        if (resp?.state === 1) {
          logstatus = 'Login OK';
          window.location.href = `${environment.WEB_URL}?token=${resp.tokenFramework}`;
        } else {
          logstatus = 'Login activar';
          this.service.approvedUser.next(this.username);
          this.service.token = resp.tokenFramework;
          this.router.navigate(['/activar']);
        }
      } catch (e) {
        this.isError = true;
        if (e.error.statusCode !== 401) {
          logstatus = 'Login no autorizado';
          this.snackBar.open(
            'Ha ocurrido un problema procesando su solicitud',
            'cerrar',
            this.snackbarConfig
          );
        } else {
          logstatus = 'Login error';
          this.snackBar.open(e.error.message, 'cerrar', this.snackbarConfig);
        }
        this.loginForm.get('recaptcha').reset();
      } finally {
        this.isLoading = false;
      }
    }
  }

  public showModal(): void {
    this.bsModalRef = this.modalService.show(ModalRecuperarContrasenaComponent);
  }
}
